import { useCallback, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import * as Yup from 'yup';

import { ButtonBlack, Input, Modal } from '~/components';
import { useTrainingStore } from '~/hooks/trainingStore';
import getValidationErrors from '~/utils/getValidationErrors';

import {
  Card,
  Container,
  DeleteContainer,
  EditContainer,
  NoData,
  RowButtons,
  RowContent,
} from './styles';

type Segment = {
  id: number;
  professional_id: number;
  category: string;
  created_at: string;
  updated_at: string;
  description: string;
};

type Props = {
  segments: Segment[];
  isAdminData: boolean;
};

export function Segment({ segments, isAdminData }: Props) {
  const { deleteCategoryItem, editCategoryItem } = useTrainingStore();

  const [selectedSegment, setSelectedSegment] = useState<Segment>(
    {} as Segment,
  );
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  function EditModal() {
    const formRef = useRef<FormHandles>(null);

    const [loading, setLoading] = useState(false);

    const handleSubmit = useCallback(async (data) => {
      setLoading(true);

      const schema = Yup.object().shape({
        description: Yup.string().required('O campo é obrigatório!'),
      });

      try {
        await schema.validate(data, { abortEarly: false });

        const formData = {
          ...selectedSegment,
          description: data.description,
        };

        editCategoryItem(formData);

        setEditModal(false);
      } catch (err) {
        console.log(err);
        setLoading(false);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        }
      }
    }, []);

    return (
      <Modal isOpen={editModal} setOpen={setEditModal}>
        <EditContainer>
          <h1>Atualizar {selectedSegment.description}</h1>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input
              name="description"
              fontSize="1.5rem"
              containerStyle={{
                padding: '0 1.7rem',
                height: '3.8rem',
              }}
              placeholder="Novo nome"
            />
          </Form>

          <ButtonBlack
            disabled={loading}
            onClick={() => {
              formRef.current?.submitForm();
            }}
          >
            Atualizar
          </ButtonBlack>
        </EditContainer>
      </Modal>
    );
  }

  function DeleteModal() {
    const [loading, setLoading] = useState(false);

    function handleDelete() {
      deleteCategoryItem(selectedSegment);
      setDeleteModal(false);
      setLoading(false);
    }

    return (
      <Modal isOpen={deleteModal} setOpen={setDeleteModal}>
        <DeleteContainer>
          <h1>Atenção</h1>

          <p>
            Tem certeza que deseja excluir o item &quot;
            {selectedSegment.description}&quot;?
          </p>

          <div>
            <button
              disabled={loading}
              type="button"
              onClick={() => {
                setLoading(true);
                handleDelete();
              }}
            >
              Sim
            </button>

            <button type="button" onClick={() => setDeleteModal(false)}>
              Não
            </button>
          </div>
        </DeleteContainer>
      </Modal>
    );
  }

  return (
    <Container>
      <EditModal />
      <DeleteModal />

      <ul>
        {segments.length > 0 ? (
          segments.map((segment) => (
            <Card key={segment.id}>
              <RowContent>
                <p>{segment.description}</p>
              </RowContent>

              {!isAdminData && (
                <RowButtons>
                  <MdEdit
                    color="#fcba03"
                    size={28}
                    onClick={() => {
                      setSelectedSegment(segment);
                      setEditModal(true);
                    }}
                  />

                  <FaTrash
                    color="#f32314"
                    size={26}
                    onClick={() => {
                      setSelectedSegment(segment);
                      setDeleteModal(true);
                    }}
                  />
                </RowButtons>
              )}
            </Card>
          ))
        ) : (
          <NoData>
            Nenhum segmento cadastrado.
            <br />
            Adicione um segmento clicando no botão de adicionar.
          </NoData>
        )}
      </ul>
    </Container>
  );
}
